"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexDimensions = void 0;
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./typings"), exports);
var FlexDimensions_1 = require("./FlexDimensions");
Object.defineProperty(exports, "FlexDimensions", { enumerable: true, get: function () { return FlexDimensions_1.FlexDimensions; } });
//# sourceMappingURL=index.js.map